import React from 'react'
import cn from 'classnames'
import CarbonGrid from '../../../Grid'
import './index.scss'

const UbliqueGrid = ({ children, className }) => {
  return (
    <CarbonGrid className={cn('ublique-grid-template', className)}>
      {children}
    </CarbonGrid>
  )
}

export default UbliqueGrid
